var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgConnectOk = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 33,
  height: 32,
  viewBox: "0 0 33 32",
  fill: "#005FF9",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  width: 32,
  height: 32,
  rx: 16
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24.5303 11.2197C24.8232 11.5126 24.8232 11.9874 24.5303 12.2803L15.0303 21.7803C14.7374 22.0732 14.2626 22.0732 13.9697 21.7803L9.46967 17.2803C9.17678 16.9874 9.17678 16.5126 9.46967 16.2197C9.76256 15.9268 10.2374 15.9268 10.5303 16.2197L14.5 20.1893L23.4697 11.2197C23.7626 10.9268 24.2374 10.9268 24.5303 11.2197Z",
  fill: "white"
})));
export { SvgConnectOk as ReactComponent };